<template>
    <div style="width:120rem; margin: 0 auto">
        <div class="footerBox">
            <div class="footerBoxTop">
                <div class="footLeft">
                    <img src="../assets/img/bottomLogo.png" alt="">
                    <div class="messageBox" style="color: aliceblue;">
                        <span><a href="/m/">会员</a></span>
                    </div>
                </div>
                <div class="footRight">
                    <div class="messageBox" style="color: aliceblue;">
                        <span>电话：{{ tel }}</span>
                        <span>邮箱：{{ email}}</span>
                    </div>
                    
                </div>
            </div>
            <div class="footerBoxBottom">
                <span>copyright@2024本草纪（唐山）健康咨询有限公司 All Rights Reserved</span>
                <span>{{ icp }} </span>
             
            </div>
        </div>
    </div>


</template>
<script>
export default {
    props: {
        msg: String
    },
    data() {
        return {
            activeIndex: '1',
            tel: "400-1535-345",
            email: "110728680@qq.com",
            icp : "冀ICP备2024081232号-1"
        };
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
.right17 {
    margin-right: 1.0625rem;
}

.footerBox {
    width: 84.375rem;
    height: 23.9375rem;
    background: #0FA17D;
    padding: 5rem 17.75rem 0 17.75rem;

    .footerBoxTop {
        padding-left: 2.25rem;
        border-bottom: .0625rem solid #fff;
        height: 18.75rem;
        display: flex;
        justify-content: space-between;

        .footLeft {
            img {
                width: 27.125rem;
                height: 3.6875rem;
                margin-bottom: 3.125rem;
            }

            .messageBox {
                width: 19.125rem;

                span {
                    display: block;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: .875rem;
                    color: #FFFFFF;
                    line-height: 2.25rem;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    letter-spacing: .125rem;
                    a{
                        color:#FFFFFF;
                    }
                }
            }
        }

        .footRight {
            margin-left: 5.75rem;
            .messageBox {
                width: 19.125rem;

                span {
                    display: block;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: .875rem;
                    color: #FFFFFF;
                    line-height: 2.25rem;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    letter-spacing: .125rem;
                }
            }
            .lineOne {
                padding-bottom: 1.875rem;
                border-bottom: .0625rem solid #FFFFFF;

                .lineOneText {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 1rem;
                    color: #FFFFFF;
                    line-height: 1.625rem;
                    text-align: right;
                    font-style: normal;
                    text-transform: none;
                    letter-spacing: .125rem
                }

                .lineOneText1 {
                    letter-spacing: .125rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: .75rem;
                    color: #FFFFFF;
                    line-height: 1.625rem;
                    text-align: right;
                    font-style: normal;
                    text-transform: none;
                }
            }

            .lineTwo {
                border-bottom: .0625rem solid #FFFFFF;
                padding: 1.375rem 0;
                display: flex;
                justify-content: space-evenly;
                align-items: center;

                .lineTwoPhone {

                    span {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 1.875rem;
                        color: #FFFFFF;
                        line-height: 1.625rem;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }

                    img {
                        width: 1.75rem;
                        height: 1.75rem;
                        margin-right: 1.25rem
                    }

                }

                .lineTwoBtn {
                    background: #FFFFFF;
                    border-radius: .5rem .5rem .5rem .5rem;
                    width: 18.75rem;
                    height: 3.375rem;
                    text-align: center;
                    line-height: 3.375rem;

                    span {
                        font-size: 1.125rem;
                        color: #009B75;

                        background: #FFFFFF;
                        border-radius: .5rem .5rem .5rem .5rem;
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        font-weight: bold;
                    }

                    img {
                        width: 1.125rem;
                        height: .875rem;
                        margin-right: 2.5rem;
                    }
                }
            }

            .lineThree {
                .footerTabStyle {
                    padding-top: 1.5625rem;

                    .box {
                        width: 6.75rem;
                        display: inline-block;
                        margin-right: 3.875rem;
                    }

                    span {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: .875rem;
                        color: #FFFFFF;
                        line-height: 2.25rem;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }
            }
        }
    }

    .footerBoxBottom {
        display: flex;
        justify-content: space-evenly;
        padding-top: 1.25rem;

        span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .875rem;
            color: rgba(255, 255, 255, 0.5);
            line-height: 2.375rem;
            text-align: justifyLeft;
            font-style: normal;
            text-transform: none;
        }
    }
}
</style>